/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

import { Theme as MaterialTheme, useTheme, Paper, Stack, TextField, Button, Typography, Container, InputAdornment, IconButton, Backdrop, CircularProgress } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { useState } from "react";

import { useTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import DatagridDocuments from '../components/DatagridDocuments';
import DialogDocumentApprover from '../components/DialogDocumentApprover';
import { Close } from '@mui/icons-material';
import ApproverBusinessLogic from '../../../businessLogic/ApproverBusinessLogic';
import { IApproverDocumentGuiModel } from '../../../model/IApproverGuiModel';

const DocumentsMy = (): JSX.Element => {

    const { organizationId } = useParams();

    const theme = useTheme();

    const { t, i18n } = useTranslation();
    const [loader, setLoader] = useState(false);

    //##########################################################################################################

    const [open, setOpen] = useState(false);

    const [searchPending, setSearchPending] = useState("");
    const [searchPostponed, setSearchPostponed] = useState("");

    const [documents, setDocuments] = useState<IApproverDocumentGuiModel[]>([]);
    const [startApprovingMessage, setStartApprovingMessage] = useState<string>("");

    const openDialogStartApproving = async () => {

        let logic = new ApproverBusinessLogic();
        setLoader(true);
        const result = await logic.getApproverDocuments(organizationId ? organizationId : "", "Mine", "ApprovalPending");
        setLoader(false);
        if (result.hasErrors) {
            if (result.errors.length > 0) {
                setStartApprovingMessage(t("approver.errorWithGettingDocuments") + result.errors.join(", "));
            } else {
                setStartApprovingMessage(t("approver.errorWithGettingDocuments"));
            }
        } else {
            setDocuments(result.value);
            if (result.value.length === 0) {
                setStartApprovingMessage(t("approver.nothingToApprove"));
            } else {
                setStartApprovingMessage("");
                setOpen(true);
            }  
        }
    }
    

const closeDialog = () => {
    setOpen(false);
    setDocuments([]);
}
    //#######################################################################
    //#######################################################################
    //#######################################################################
    return <main>
        <Grid container direction="column" wrap="nowrap"
            sx={{
                display: open ? "none" : "flex",
                padding: theme.spacing(2),
                width: "100%",
                height: {
                    //xs: "calc(100vh - " + appBarHeight + "px )",
                    lg: "calc(100vh)"
                },
                //"& .MuiDataGrid-columnHeaders": { backgroundColor: theme.palette.info.main, color: "white" },
                //"& .MuiDataGrid-footerContainer": { backgroundColor: theme.palette.info.main, color: "white" }
            }}>

            <Container component={Paper} sx={{ display: "flex", flex:"1 1 auto", flexDirection: "column" }}>
                <Grid container paddingBottom={theme.spacing(4)} paddingTop={theme.spacing(4)}>
                    <Grid xs={12}>
                        <Button
                            fullWidth
                            onClick={openDialogStartApproving}
                            size="small"
                            variant="contained"
                            color="secondary">{t("approver.startApproving")}
                        </Button>
                    </Grid>
                    <Grid xs={12} display="center" justifyContent="center" margin="1rem">
                        <Typography variant="body1">{startApprovingMessage}</Typography>
                    </Grid>
                </Grid>
                <Grid paddingBottom={theme.spacing(2.5)} flex="1 1 auto">
                    <Stack direction="column" width="100%" height="100%" minHeight="40rem">
                        <Stack direction="row" spacing={3} alignItems="center" justifyContent="space-between">
                            <Typography variant="h6">{t("basic.pendingDocuments")}</Typography>
                            <TextField size="small" variant="outlined" color="warning" value={searchPending} sx={{ width: "16rem", }}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment position="end" component={IconButton} onClick={() => setSearchPending("")}
                                            sx={{ display: searchPending ? "inherit" : "none" }}><Close /></InputAdornment>,
                                }}
                                onChange={(e) => setSearchPending(e.target.value)}
                                id="searchPendingDocuments" label={t("search.search") + " " + t("basic.pendingDocuments").toLowerCase()} />
                        </Stack>
                        {!open && <DatagridDocuments org={organizationId ? organizationId : ""} type="Mine" status="ApprovalPending" onlyActive={true} />}
                        <Stack direction="row" spacing={3} alignItems="center" justifyContent="space-between">
                            <Typography variant="h6">{t("basic.postponedDocuments")}</Typography>
                            <TextField size="small" variant="outlined" color="warning" value={searchPostponed} sx={{ width: "16rem", }}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment position="end" component={IconButton} onClick={() => setSearchPostponed("")}
                                            sx={{ display: searchPostponed ? "inherit" : "none" }}><Close /></InputAdornment>,
                                }}
                                onChange={(e) => setSearchPostponed(e.target.value)}
                                id="searchPostponedDocuments" label={t("search.search") + " " + t("basic.postponedDocuments").toLowerCase()} />
                        </Stack>
                        {!open && <DatagridDocuments org={organizationId ? organizationId : ""} type="Mine" status="ApprovalPostponed" onlyActive={true} />}
                    </Stack>
                </Grid>
            </Container>
        </Grid>
        {(open && documents.length > 0) && <DialogDocumentApprover open={open} closeDialog={closeDialog} approverDocument={undefined} approverDocuments={documents} organizationId={organizationId} />}
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loader}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    </main>

}
export default DocumentsMy;